<base-detail-page [config]="baseDetailPageConfig"></base-detail-page>
